import type { ApiResponse } from '@super/shared-types'
import { BaseApiClient } from './base-client'
import type { InferredFormItem, InferenceRequest } from '@super/node-graph-ui'

/**
 * Admin inference client for the Form Node authoring UI. Posts the author's
 * free-prose line to the API; the API returns the structured fields
 * (id, kind, answerType, required, templateVars, scratchpadPath) that the
 * drawer pre-populates.
 */
export class FormNodeApiClient extends BaseApiClient {
  async inferItem(request: InferenceRequest): Promise<InferredFormItem | null> {
    try {
      // SuperDataAdminGuard-protected endpoint; session cookies ride along
      // via BaseApiClient's `credentials: 'include'`.
      // API wraps responses in { data, correlationId, timestamp } — unwrap.
      const response = await this.request<ApiResponse<InferredFormItem>>(
        '/api/admin/form-node/infer-item',
        {
          method: 'POST',
          body: JSON.stringify(request),
        },
      )
      return response.data ?? null
    } catch (error) {
      // Soft-fail: inference is advisory, not required. Surface a console
      // warning so devs see it in Vite logs; the drawer-touched flag means
      // the author can always override anything the inference misses.
      // eslint-disable-next-line no-console
      console.warn('[form-node] inference failed', error)
      return null
    }
  }
}

export const formNodeApiClient = new FormNodeApiClient()
